import clsx from 'clsx'
import React from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import s from './styles.module.scss'

import { AdultsPickerModeEnum } from './adults-picker.enum'
import { AdultsSearchBarPicker } from './AdultsSearchBarPicker'
import { TravelTypeEnum } from '../../../lib/graphql'

type AdultsPickerInputFieldProps = {
  alternativeClassName: string
  field: ControllerRenderProps<FieldValues, string>
  isMobile: boolean
  revampPicker: boolean
  mode: AdultsPickerModeEnum
  isFocused: boolean
  isAdultsSelected: boolean
  travelType: TravelTypeEnum
}

export const AdultsPickerInputField: React.FC<AdultsPickerInputFieldProps> = ({
  alternativeClassName,
  field,
  isMobile,
  revampPicker,
  mode,
  isFocused,
  isAdultsSelected,
  travelType,
}) => {
  return (
    <div
      className={clsx(s.adults, s[alternativeClassName], {
        [s.focused]: isFocused,
      })}
      data-testid='adults-picker'
    >
      <AdultsSearchBarPicker
        mode={mode}
        className={alternativeClassName}
        revampPicker={revampPicker}
        fieldValue={field.value}
        isMobile={isMobile}
        isAdultsSelected={isAdultsSelected || !!field.value}
        travelType={travelType}
      />
    </div>
  )
}
